import { ReactComponent as DataBase } from './database.svg';
import { ReactComponent as InProgress } from './inprogress.svg';
import { ReactComponent as History } from './history.svg';
import { ReactComponent as PlusWhite } from './plus-white.svg';
import { ReactComponent as Play } from './play.svg';
import { ReactComponent as Edit } from './edit.svg';
import { ReactComponent as DataBaseFilled } from './database-filled.svg';
import { ReactComponent as StopHand } from './stop-hand.svg';
import { ReactComponent as S3 } from './s3.svg';
import { ReactComponent as SnowFlake } from './snowflake.svg';
import { ReactComponent as Epic } from './epic.svg';
import { ReactComponent as ChevronRight } from './chevron-right.svg';
import { ReactComponent as ChevronLeft } from './chevron-left.svg';
import { ReactComponent as HealthLake } from './health-lake.svg';
import { ReactComponent as HttpPlugin } from './http-plugin.svg';
import { ReactComponent as AwsHealthImaging } from './aws-healthimaging.svg';

export const icons = {
    DataBase,
    InProgress,
    History,
    PlusWhite,
    Play,
    Edit,
    DataBaseFilled,
    StopHand,
    S3,
    SnowFlake,
    Epic,
    ChevronRight,
    ChevronLeft,
    HealthLake,
    HttpPlugin,
    AwsHealthImaging,
};
